import { buildTestIds } from "application";
import { Installment } from "../Installment/Installment.component";
import * as InstallmentsSub from "./Installments.styles";
import { InstallmentsProps } from "./Installments.types";

export const Installments = ({ data }: InstallmentsProps) => {
  return (
    <InstallmentsSub.Container {...buildTestIds("installments-container")}>
      {data &&
        data.map(({ hasFees, price, totalPrice }, index) => (
          <Installment
            price={price}
            quantity={index + 1}
            hasFees={hasFees}
            totalPrice={totalPrice}
            isHighlighted={index % 2 === 0}
            key={`installment-${price}`}
          />
        ))}
    </InstallmentsSub.Container>
  );
};
